import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import { InstagramComponent } from '@shared/components/instagram';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-gallery-layout-2',
  imports: [TitleComponent, ButtonComponent, InstagramComponent],
  templateUrl: './gallery-layout-2.component.html',
  styleUrl: './gallery-layout-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout2Component {
  title: Title = {
    level: 'SPAN',
    size: {
      mobile: 'H2',
      desktop: 'H3',
    },
    text: 'Suivez-nous sur Instagram.',
    align: {
      mobile: 'CENTER',
      desktop: 'CENTER',
    },
  };
}
